import { render, staticRenderFns } from "./IconHeadphoneChef.vue?vue&type=template&id=753271f9&"
import script from "./IconHeadphoneChef.vue?vue&type=script&lang=js&"
export * from "./IconHeadphoneChef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports